import React from "react";

import {
  formatDateTime,
  getStartDateFormatter,
  formatAddress,
  getTimezoneDate,
  timezones,
} from "../../../utilities/helpers";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Badge from "react-bootstrap/Badge";

import placeholder from "../../../assets/placeholder.png";

import "./eventModal.scss";

export default function EventModal({ show, handleClose, event }) {
  let timezone = timezones(event?.venue?.timezone);

  return (
    <Modal
      id="event-modal"
      fullscreen="md-down"
      scrollable
      centered
      animation={false}
      show={show}
      onHide={handleClose}
    >
      <Modal.Header closeButton className="mb-0">
        <Modal.Title as="h4">Event description</Modal.Title>
      </Modal.Header>
      <div className="event-details mb-3">
        <Row className="justify-content-between align-items-center mb-2">
          <Col xs={8} className="flex-grow-1">
            <h1 className="event-name m-0 heading-sm">{event?.name}</h1>
          </Col>
          <Col xs="auto" className="d-flex align-self-center">
            <Badge className="ms-auto badge-outline badge-outline--primary">
              {/* {event?.categories[0]?.name} */}
            </Badge>
          </Col>
        </Row>
        <div className="mb-2">
          <span className="normal-sm">
            {formatDateTime(
              getTimezoneDate(event?.start, timezone),
              getStartDateFormatter(event),
            )}
          </span>
        </div>
        <div className="mb-2">
          <span className="normal-sm">{event?.venue?.name}</span>
        </div>
        <div>
          <span className="normal-sm">
            {formatAddress(event?.venue)}{" "}
            <a
              href={`https://google.com/maps?q=${event?.venue?.address[0]?.address_1}+${event?.venue?.address[0]?.city}+${event?.venue?.address[0]?.state}`}
              target="_blank"
            >
              Directions
            </a>
          </span>
        </div>
      </div>
      <Modal.Body>
        <img
          src={event?.image?.url || placeholder}
          alt={`Cover art for ${event?.name} event`}
          width="225"
          height="225"
          className="event-image mb-3"
        />
        {event?.summary && (
          <>
            <h4 className="normal mb-2">Additional info</h4>
            <pre>{event?.summary}</pre>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
